import store from '../store/store';
import { authActions } from '../store/authSlice/authSlice';

export const sessionStorageTransferHandler = function (e) {
    if (!e.newValue) return;

    if (e.key === 'UserLoggedOut') {
        sessionStorage.removeItem('user');
        store.dispatch(authActions.logoutStart());
    }

    if (e.key === 'UserLoggedIn') {
        let user = JSON.parse(e.newValue);
        if (user) {
            sessionStorage.setItem('user', JSON.stringify(user));
            store.dispatch(authActions.setUser(user));
        }
    }
};

export function sendLocalStorageSignal(key, value = '_') {
    localStorage.setItem(key, JSON.stringify(value));
    setTimeout(() => localStorage.removeItem(key), 100);
}
